export default (prefix, style) => (style ? `${prefix}-${style}` : "")
